import consumer from "./consumer"

document.addEventListener("turbo:load", () => {
    const messagesContainer = document.getElementById("messages")
    if (!messagesContainer) return

    const discussionId = messagesContainer.dataset.discussionId

    consumer.subscriptions.create(
        { channel: "DiscussionChannel", discussion_id: discussionId },
        {
            connected() {
                console.log(`🔗 Subscribed to DiscussionChannel ${discussionId}`)
            },
            disconnected() {
                console.log(`🔌 Unsubscribed from DiscussionChannel ${discussionId}`)
            },
            received(data) {
                if (data.html) {
                    messagesContainer.insertAdjacentHTML("beforeend", data.html)

                    if (window.applyMessageClasses) window.applyMessageClasses()

                    messagesContainer.scrollTop = messagesContainer.scrollHeight
                }

                if (data.json) {
                    console.log("💬 JSON reçu :", data.json)
                }
            }
        }
    )

    messagesContainer.scrollTop = messagesContainer.scrollHeight
})
